@if (imageItems?.length > 0) {
    <div class="grid-container">
      @for (item of imageItems; track $index) {
        <div class="grid-item" 
          id="{{item.page}}"
          pDraggable="dd"
          pDroppable="dd" style="cursor: move;"         
          (onDragStart)="drag($event)"
          (onDrop)="drop($event)"
>
          <image [imageItem]="item"
                [contextMenu]="contextMenu"
                (onMenuAction)="menuAction($event)"
          ></image>
        </div>
      }
    </div>
  }